import { AnimatePresence, motion } from "framer-motion";
import { ReactNode } from "react";
import { Icon, IconButton } from "~components";
import { Css, Palette } from "~generated/css";
import { useEscCapture, useTestIds } from "~utils";

type ModalProps = {
  bg?: Palette;
  children?: ReactNode;
  close: () => void;
  isOpen: boolean;
  title?: string;
  maxView?: boolean;
};

export function ModalWrapper(props: ModalProps) {
  const { bg = Palette.White, children, close, isOpen, title, maxView = false } = props;
  const tid = useTestIds(props, "modal-wrapper");
  useEscCapture(close);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          key="modal-wrapper"
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0 }}
          transition={{ duration: 0.3 }}
          css={Css.fixed.z9999.top0.bottom0.left0.right0.df.$}
          {...tid}
        >
          <div css={Css.w100.h100.bgColor(bg).df.ma.fdc.oya.relative.$}>
            {!maxView && (
              // FIXME: why do we have excessive divs?
              <div css={Css.df.w100.ifMobileOrTablet.bgWhite.else.bgOffWhite.$}>
                <div css={Css.df.jcsb.aic.h8.w100.px3.$}>
                  <div css={Css.t24.$}>{title}</div>
                  <button type="button" css={Css.cursorPointer.$} onClick={close}>
                    <Icon name="x-32" />
                  </button>
                </div>
              </div>
            )}
            {maxView && (
              <div css={Css.absolute.top2.right2.z1.$}>
                <IconButton icon="collapse" color="primary" size="medium" shape="square" onClick={close} />
              </div>
            )}
            {children}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
